// Unauthorized.tsx
import React from "react";
import { Link } from "react-router-dom";

const AccessDenied: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-violet-50 text-center">
      <div className="p-8 bg-white shadow-lg rounded-lg">
        <h1 className="text-2xl font-bold text-violet-700">Access Denied</h1>
        <p className="mt-4 text-md text-gray-600">
          You don't have access, please contact the administrator
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;
